import { useState } from "react";
import { ZoomIn } from "lucide-react";

const KEY = "fhp-big";
const read = () => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };
const apply = (on) => document.documentElement.classList.toggle("big", on);
apply(read());

export function BigTextRow({ t }) {
  const [on, setOn] = useState(read);
  const flip = () => {
    const next = !on;
    setOn(next); apply(next);
    try { localStorage.setItem(KEY, next ? "1" : "0"); } catch { /* private mode */ }
  };
  return (
    <button type="button" className="more-row" data-testid="big-text-toggle" aria-pressed={on} onClick={flip}>
      <ZoomIn size={26} className="more-icon" />
      <span className="more-text"><span className="more-title">{t("Big text and buttons")}</span>
        <span className="card-sub">{t("Easier to read with a flashlight or gloves")}</span></span>
      <span className={`switch ${on ? "switch-on" : ""}`} data-testid="big-text-state"><span /></span>
    </button>
  );
}
